import React from 'react';

import {AdvancedSettingsDropdown} from 'schemas/fields/AdvancedSettingsDropdown';
import {AdvancedSettingsIconProps, getUnitDropdownOption} from 'schemas/fields/AdvancedSettingsIconUtils';

export default function SchemaInterfaceFieldAdvancedSettingsIcon(
  props: AdvancedSettingsIconProps
): JSX.Element {
  const options = [getUnitDropdownOption(props)];
  return <AdvancedSettingsDropdown options={options} />;
}
